import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from "../../helper/urls.js";
// import { FaUser } from "react-icons/fa";
const Login = () => {
  //   const navigate = useNavigate();
  //   const url = `${baseUrl}/api/counselors/login`;
  //   const [formData, setFormData] = useState({
  //     email: "",
  //     password: "",
  //     // role: "",
  //   });

  //   const handleChanges = (e) => {
  //     const { name, value } = e.target;
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: value,
  //     }));
  //   };

  //   const formSubmited = async (e) => {
  //     e.preventDefault();
  //     try {
  //       const { email, password } = formData;

  //       const data = { email, password };
  //       const response = await axios.post(url, data);

  //       if (response.status === 200 && response?.data?.token) {
  //         toast.success(response.data.message);
  //         localStorage.setItem("token", response.data.token);
  //         localStorage.setItem("user", "counselor");
  //         localStorage.setItem("name", response.data.counselor.firstName +" "+response.data.counselor.lastName);
  //         localStorage.setItem("email", response.data.counselor.email);

  //         // setTimeout(
  //         //   () => navigate("/booking-counselor", { state: response.data.counselor }),
  //         //   500
  //         // );
  //         navigate("/booking-counselor");
  //       } else {
  //         // console.log("respomse", response);
  //         toast.error(response.data.error);
  //       }
  //     } catch (error) {
  //       console.error("Login failed:", error);
  //       toast.error("Login failed. Please check your credentials.");
  //     }
  //   };

  //   return (
  //     <>
  //       <ToastContainer position="top-right" autoClose={3000} />
  //       <section className="auth bg-base d-flex flex-wrap">
  //         <div className="auth-left d-lg-block d-none">
  //           <div className="d-flex align-items-center flex-column h-100 justify-content-center">
  //             <img src="assets/images/auth/auth-img.png" alt="" />
  //           </div>
  //         </div>
  //         <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
  //           <div className="max-w-464-px mx-auto w-100">
  //             <div>
  //               <Link to="/" className="mb-40 max-w-290-px">
  //                 <img src="assets/images/logo.png" alt="" />
  //               </Link>
  //               <h4 className="mb-12">Sign In to your Account</h4>
  //               <p className="mb-32 text-secondary-light text-lg">
  //                 Welcome back! please enter your detail
  //               </p>
  //             </div>
  //             <form onSubmit={formSubmited}>
  //               {/* <div className="icon-field mb-16">
  //                 <span className="icon top-50 translate-middle-y">
  //                   <Icon icon="fa-regular:user" />
  //                 </span>
  //                 <select
  //                   name="role"
  //                   id="role"
  //                   onChange={handleChanges}
  //                   className="form-control h-56-px bg-neutral-50 radius-12"
  //                 >
  //                   <option value="select role" hidden>
  //                     Select Role
  //                   </option>
  //                   <option value="admin">Admin</option>
  //                   <option value="counselor">Counselor</option>
  //                   <option value="student">Student</option>
  //                 </select>
  //               </div> */}
  //               <div className="icon-field mb-16">
  //                 <span className="icon top-50 translate-middle-y">
  //                   <Icon icon="mage:email" />
  //                 </span>
  //                 <input
  //                   type="email"
  //                   className="form-control h-56-px bg-neutral-50 radius-12"
  //                   placeholder="Email"
  //                   name="email"
  //                   value={formData.email}
  //                   onChange={handleChanges}
  //                   required
  //                 />
  //               </div>
  //               <div className="position-relative mb-20">
  //                 <div className="icon-field">
  //                   <span className="icon top-50 translate-middle-y">
  //                     <Icon icon="solar:lock-password-outline" />
  //                   </span>
  //                   <input
  //                     type="password"
  //                     className="form-control h-56-px bg-neutral-50 radius-12"
  //                     id="your-password"
  //                     placeholder="Password"
  //                     name="password"
  //                     value={formData.password}
  //                     onChange={handleChanges}
  //                     required
  //                   />
  //                 </div>
  //                 <span
  //                   className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
  //                   data-toggle="#your-password"
  //                 />
  //               </div>
  //               <div className="d-flex justify-content-between gap-2">
  //                 <Link to="#" className="text-primary-600 fw-medium">
  //                   Forgot Password?
  //                 </Link>
  //               </div>
  //               <button
  //                 type="submit"
  //                 className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
  //               >
  //                 Sign In
  //               </button>
  //             </form>
  //           </div>
  //         </div>
  //       </section>
  //     </>
  //   );
  // };
  // const location = useLocation();
  // const navigate = useNavigate();
  // const [token, setToken] = useState("");
  // const [userType, setUserType] = useState("");
  // // const [name, setName] = useState("");
  // // const [email, setEmail] = useState("");
  // //  const [status, setStatus] = useState("");

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(location.search);
  //   const tokenParam = searchParams.get("token");
  //   const userParam = searchParams.get("user");
  //   // const nameParam = searchParams.get("name");
  //   // const emailParam = searchParams.get("email");
  //   //  const statusParam = searchParams.get("status");

  //   if (tokenParam) {
  //     setToken(tokenParam);
  //     sessionStorage.setItem("token", tokenParam); // Save token to session storage
  //   }

  //   if (userParam) {
  //     setUserType(userParam);
  //     sessionStorage.setItem("user", userParam); // Save user type
  //   }

    // if (nameParam) {
    //   setName(nameParam);
    //   sessionStorage.setItem("name", nameParam); // Save name
    // }

    // if (emailParam) {
    //   setEmail(emailParam);
    //   sessionStorage.setItem("email", emailParam); // Save email
    // }
    //  if (statusParam) {
    //   setStatus(statusParam);
    //   sessionStorage.setItem("status", statusParam); // Save email
    // }

    // if (statusParam==2) {
      
    //     navigate("/counselor-profile");
    // }
    // else if (statusParam==1) {
      
    //     navigate("/upcoming-bookings");
    // }
    

    // Optionally, remove the parameters from the URL after processing
    // to keep the URL clean.
  //   navigate(location.pathname, { replace: true });
   
  // }, [location, navigate]);

  return (
    <div>
      {/* <h1>Login Page</h1>
      {token && <p>Token: {token}</p>}
      {userType && <p>User Type: {userType}</p>}
      {name && <p>Name: {name}</p>}
      {email && <p>Email: {email}</p>} */}

      {/* Your login form or other UI elements */}
    </div>
  );
};

export default Login;
